//data for about zicofe section
export const SectionAinfo = {
    id:'SelfIntro',
    TitleText:'Hi, I am Rubanza Silver',
    headline:'A coder with a background in Software Engineering',
    text:'My work and interest lie in working on various steps of the machine learning lifecycle from Exploratory Data Analysis, Data wrangling, Feature Engineering to Model building, deployment, testing, monitoring, etc.',
    text3:'I integrate machine learning models into general software solutions, all in the context of solving a given problem. Likewise, I am proficient with Python, PyTorch, and many other libraries such as fastai, sklearn, etc.',
    text1:'I also have over 6 years of experience developing software applications using HTML, CSS, Javascript, React JS, etc.',
    text2:'Below are examples of my work',
    imgStart:false,
    // img:'https://d322abd807wvow.cloudfront.net/suwik-photos/eatGreen.jpeg',
    img:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/silverPotraitCompressed.webp',
    alt:'Picture of Rubanza Silver',
};



